import React from 'react';
import { loadCurrentState } from '../storage';
import { useCheckboxWithTimestamp } from '../hooks/useCheckboxWithTimestamp';

export const useRoomEquipmentStatus = () => {
  const saved = loadCurrentState();
  const equipment = saved?.roomEquipment || {};
  const states = [
    equipment.heatedIncubator,
    equipment.roomHeating,
    equipment.heatingBags,
    equipment.chemicalMattress,
    equipment.warmSheets,
    equipment.portableBlower,
    equipment.babyHat
  ];
  const checked = states.filter(Boolean).length;
  return { checked, total: 7 };
};

const RoomEquipment: React.FC = () => {
  const saved = loadCurrentState();

  const [heatedIncubator, setHeatedIncubator] = useCheckboxWithTimestamp(
    'roomEquipment',
    'heatedIncubator',
    saved?.roomEquipment?.heatedIncubator || false
  );
  const [roomHeating, setRoomHeating] = useCheckboxWithTimestamp(
    'roomEquipment',
    'roomHeating',
    saved?.roomEquipment?.roomHeating || false
  );
  const [heatingBags, setHeatingBags] = useCheckboxWithTimestamp(
    'roomEquipment',
    'heatingBags',
    saved?.roomEquipment?.heatingBags || false
  );
  const [chemicalMattress, setChemicalMattress] = useCheckboxWithTimestamp(
    'roomEquipment',
    'chemicalMattress',
    saved?.roomEquipment?.chemicalMattress || false
  );
  const [warmSheets, setWarmSheets] = useCheckboxWithTimestamp(
    'roomEquipment',
    'warmSheets',
    saved?.roomEquipment?.warmSheets || false
  );
  const [portableBlower, setPortableBlower] = useCheckboxWithTimestamp(
    'roomEquipment',
    'portableBlower',
    saved?.roomEquipment?.portableBlower || false
  );
  const [babyHat, setBabyHat] = useCheckboxWithTimestamp(
    'roomEquipment',
    'babyHat',
    saved?.roomEquipment?.babyHat || false
  );

  return (
    <div className="section-content-wrapper" style={{ padding: '20px', direction: 'rtl' }}>
      <div className="checkbox-group">
        <label className="checkbox-label">
          <input
            type="checkbox"
            checked={heatedIncubator}
            onChange={(e) => setHeatedIncubator(e.target.checked)}
          />
          <span>אינקובטור מחומם + שאטל</span>
        </label>
      </div>

      <div className="checkbox-group">
        <label className="checkbox-label">
          <input
            type="checkbox"
            checked={roomHeating}
            onChange={(e) => setRoomHeating(e.target.checked)}
          />
          <span>חימום חדר ל-<span dir="ltr">26°C</span></span>
        </label>
      </div>

      <div className="checkbox-group">
        <label className="checkbox-label">
          <input
            type="checkbox"
            checked={heatingBags}
            onChange={(e) => setHeatingBags(e.target.checked)}
          />
          <span>הכנת שקיות חימום. במידה וניתוח קיסרי, לתת לאח/ות חדר ניתוח</span>
        </label>
      </div>

      <div className="checkbox-group">
        <label className="checkbox-label">
          <input
            type="checkbox"
            checked={chemicalMattress}
            onChange={(e) => setChemicalMattress(e.target.checked)}
          />
          <span>מזרן כימי</span>
        </label>
      </div>

      <div className="checkbox-group">
        <label className="checkbox-label">
          <input
            type="checkbox"
            checked={warmSheets}
            onChange={(e) => setWarmSheets(e.target.checked)}
          />
          <span>סדינים חמים</span>
        </label>
      </div>

      <div className="checkbox-group">
        <label className="checkbox-label">
          <input
            type="checkbox"
            checked={portableBlower}
            onChange={(e) => setPortableBlower(e.target.checked)}
          />
          <span>חימום נוסף עם blower נייד</span>
        </label>
      </div>

      <div className="checkbox-group">
        <label className="checkbox-label">
          <input
            type="checkbox"
            checked={babyHat}
            onChange={(e) => setBabyHat(e.target.checked)}
          />
          <span>כובע ליילוד</span>
        </label>
      </div>
    </div>
  );
};

export default RoomEquipment;
